import axios from "axios";
import { store } from "../store";
import { reauthorize, logout } from "../slices/staffSlice";

const gatewayEndPoint = process.env.REACT_APP_API_STAGING;

const axiosInstance = axios.create({ baseURL: gatewayEndPoint });

let isRefreshing = false;
let refreshSubscribers = [];

function subscribeTokenRefresh(cb) {
    refreshSubscribers.push(cb);
}

function onTokenRefreshed(newToken) {
    refreshSubscribers.forEach(cb => cb(newToken));
    refreshSubscribers = [];
}

axiosInstance.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            if (isRefreshing) {
                return new Promise((resolve) => {
                    subscribeTokenRefresh((newToken) => {
                        originalRequest.headers['authorization'] = newToken;
                        resolve(axiosInstance(originalRequest));
                    });
                });
            }

            originalRequest._retry = true;
            isRefreshing = true;

            const refreshToken = store.getState().staff.refreshToken;

            if (!refreshToken) {
                isRefreshing = false;
                store.dispatch(logout());
                return Promise.reject(error);
            }

            try {
                const response = await axios.get(
                    gatewayEndPoint + '/auth/staff/refresh_token',
                    { headers: { refreshtoken: refreshToken } }
                );
                const { accessToken, idToken } = response.data;
                store.dispatch(reauthorize({ accessToken, idToken }));
                onTokenRefreshed(accessToken);
                isRefreshing = false;
                originalRequest.headers['authorization'] = accessToken;
                return axiosInstance(originalRequest);
            } catch (refreshError) {
                isRefreshing = false;
                refreshSubscribers = [];
                store.dispatch(logout());
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
